export default "__VITE_ASSET__BPL1O$8t__"